<template>
    <div>
      <div class="popup-info popup-icon-info">
          <svg class="big-icon" style="width: 48px; height: 48px;">
            <use xlink:href="@/assets/img/big-icons-sprite.svg#barrier"></use>
          </svg>

          <div class="text mt24">
              <div class="text-size-l text-bold info-title">Администратор запретил<br>редактирование этого правила</div>

              <p class="info-text" style="line-height: 22px;">
                Если вам необходимо внести в него изменения, свяжитесь<br>
                с администратором <span class="text-bold">Алексей Земсков</span> по телефону <span class="text-bold">+7(906)077-40-70</span>
              </p>
          </div>

          <div class="mt24">
              <span class="btn btn--ico" @click="close">Понятно</span>
          </div>
      </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex'

    export default {
        name: "EditAdminDisabled",
        methods: {
            close: function () {
                this.$store.commit('popups/close', {name: this.popups.editAdminDisabled.name});
            }
        },
        computed: {
            ...mapState({
                popups: state => state.popups.items,
            }),
        }
    }
</script>

<style scoped>

</style>
